import type { AppRoute } from "@/lib/routing";
import { DashboardPage } from "./DashboardPage";

export const routes: AppRoute[] = [
  {
    index: true,
    element: <DashboardPage />,
    handle: { title: "Dashboard", keywords: ["home", "today", "overview"] },
  },
];
